import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    cancel: "Annuler"
};

export type _I18nAppointmentCard = typeof _fr;

const _en: _I18nAppointmentCard = {
    cancel: "Cancel"
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18nAppointmentCard(lang?: string): _I18nAppointmentCard {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}